import React, { Suspense, lazy, useEffect, useState } from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import { Dimmer, Loader, Segment } from 'semantic-ui-react'

import PublicRoute from 'components/Routes/PublicRoute'
import PublicClientRoute from 'components/Routes/PublicClientRoute'
import PublicClientRegisterRoute from 'components/Routes/PublicClientRegisterRoute'
import PublicDeleteAccountRoute from 'components/Routes/PublicDeleteAccountRoute'
import PrivateRoute from 'components/Routes/PrivateRoute'
import NewPublicClientRoute from 'components/Routes/NewPublicClientRoute'
import PrivateClientRoute from 'components/Routes/PrivateClientRoute'
import PrivateSuperAdminRoute from 'components/Routes/PrivateSuperAdminRoute'
import ClientRegister from './register/ClientRegister'
import ChangePassword from './login/ChangePassword'
import PasswordRecovery from './login/PasswordRecovery'
import AccountRegister from './register/AccountRegister'
import getUrlParams from '../utils/getUrlParams'
import {ReservationFormHeader} from './ClientSite/ReservationFormPage'

import {
	loginWithToken,
	clientLoginWithToken,
	driverLoginWithToken,
	loginWithExternalToken,
	setLanguage,
} from 'store/actions/app'
import { loginSuperAdmin } from '../store/actions/app'
import translations from "../utils/translations"

const HomePage = lazy(() => import('./home/HomePage'))
const LoginRoute = lazy(() => import('./login/index'))
const RolePage = lazy(() => import('./settings/RolePage'))
const RoleIndividualPage = lazy(() => import('./settings/RoleIndividualPage'))
const ConsoleSuperAdmin = lazy(() => import('./login/ConsoleSuperAdmin'))
const ClientLogin = lazy(() => import('./login/ClientLogin'))
const DeleteAccountPage = lazy(() => import('./delete_account/DeleteAccountPage'))
const CompanyQRScanningsPage = lazy(() => import('./ClientSite/CompanyQRScanningsPage'))
const OrdersPage = lazy(() => import('./ClientSite/OrdersPage'))
const SearchPage = lazy(() => import('./ClientSite/SearchPage'))
const Account = lazy(() => import('./ClientSite/Account'))
const ClientProductsPage = lazy(() => import('./ClientSite/ClientProductsPage'))
const FoodStallsPage = lazy(() => import('../components/FoodStallsPage'))
const OrderDetailsPage = lazy(() => import('./ClientSite/OrderDetailsPage'))
const NotificationsPage = lazy(() => import('./ClientSite/NotificationsPage'))
const ReservationsPage = lazy(() => import('./ClientSite/ReservationsPage'))
const ReservationFormPage = lazy(() => import('./ClientSite/ReservationFormPage'))
const DownloadRufPage = lazy(() => import('./ClientSite/DownloadRufPage'))
const SysCompanyAdministrator = lazy(() => import('./login/SysCompanyAdministrator'))
const DashboardAdministrator = lazy(() => import('./home/DashboardAdministrator'))
const SysCompanyClientsAdministrator = lazy(() => import('./login/SysCompanyClientsAdministrator'))
const MassClientSettings = lazy(() => import('./login/MassClientSettings'))

const Routers = (props) => {
	const {

		currentTranslations,
	} = props
	const [isTryingToLogin, setIsTryingToLogin] = useState(true)
	const dispatch = useDispatch();
useEffect(() => {
  const onStorage = (e) => {
    if (
      e.key === "@force_reload" &&
      (e.newValue === "1" || e.newValue === "true")
    ) {
      localStorage.removeItem("@force_reload");
      window.location.reload();
    }
  };

  window.addEventListener("storage", onStorage);

  const interval = setInterval(() => {
    const force = localStorage.getItem("@force_reload");
    if (force === "1" || force === "true") {
      localStorage.removeItem("@force_reload");
      window.location.reload();
    }
  }, 3000); // ⬅️ cada 3s es más que suficiente

  return () => {
    window.removeEventListener("storage", onStorage);
    clearInterval(interval);
  };
}, []);

	const tryToLogin = async () => {
        const searchParams = new URLSearchParams(window.location.search)
        const roleImpersonated = localStorage.getItem('@impersonate_role');
        const impersonatedFromUrl = searchParams.get('impersonated') === '1';
        const impersonatedFromStorage = localStorage.getItem('@impersonated') === '1';
        const isImpersonated = impersonatedFromUrl || impersonatedFromStorage;


        if (impersonatedFromUrl && !impersonatedFromStorage) {
            localStorage.setItem('@impersonated', '1');
        }
		// dispatch({ type: 'SET_IMPERSONATE_MODE', payload: isImpersonated });

		// TODO: CHECAR EL INICIO DE SESIÓN AUTOMÁTICO DE FACEBOOK
		const external_object = JSON.parse(localStorage.getItem('@external_token'))
		if (external_object) {
			const { platform, token } = external_object
			if (platform === 'facebook') {
				props.loginWithFacebookToken(token)
			} else if (platform === 'google') {
				props.loginWithGoogleToken(token)
			}
		} else {
			const token = localStorage.getItem('@token')
			const client_token = localStorage.getItem('@client_token')
			const employee_code = localStorage.getItem('@employee_code')
			const superAdminHeaders = localStorage.getItem('@superAdmin_headers')

			if (token) {
				if (employee_code) {
					await props.loginWithToken({ token, employee_code })
				} else {
					await props.loginWithToken({ token })
				}
			}
			if (client_token) {
				await props.clientLoginWithToken({ client_token })
			}
			if(superAdminHeaders){
				const headers = await JSON.parse(superAdminHeaders)
				props.loginSuperAdmin(headers, false)
			}
		}

		setIsTryingToLogin(false)
	}
	useEffect(() => {
		tryToLogin()
	}, [])

	//Sets language by search params
	useEffect(()=>{
		const params = getUrlParams(document.URL)
		if(params.lang === 'es' || params.lang === 'en'){
			props.setLanguage(params.lang)
		}
	}, [document.URL])

	if (isTryingToLogin) {
		return (
			<Dimmer active inverted className='padding-0'>
				<Loader inverted>Cargando</Loader>
			</Dimmer>
		)
	}

	const modulesToRender = props.user?.modules?.filter((mod) => {
		const { permisitions } = mod

		return permisitions?.ACCESS
	})

	return (
		<React.Fragment>
			<BrowserRouter>
				<Suspense
					fallback={
						<Segment className='width-100 height-100 padding-0 border-none margin-0 border-radius-0'>
							<Dimmer active inverted className='padding-0'>
								<Loader inverted>Cargando página</Loader>
							</Dimmer>
						</Segment>
					}
				>
					<Switch>
						<ChangePassword
							path='/change_password'
							component={ChangePassword}
							exact={true}
						/>

						<PasswordRecovery
							path='/recovery_password'
							component={PasswordRecovery}
							exact={true}
						/>

						<AccountRegister
							path='/account_register'
							component={AccountRegister}
							exact={true}
						/>

						<PublicDeleteAccountRoute
							path='/delete_account'
							component={DeleteAccountPage}
							exact={true}
						/>

						<PublicRoute path='/login' component={LoginRoute} exact={true} />

						<PrivateRoute path='/' component={HomePage} exact={true} />
						
						<PrivateRoute
							path='/settings/role'
							component={RolePage}
							exact={true}
						/>
						<PrivateRoute
							path='/settings/role/:id'
							component={RoleIndividualPage}
							exact={true}
						/>

						{props.isAuthenticated && (
							<>
								{modulesToRender?.map((m) => {
									const ComponentPage = lazy(() => import(`${m.folder}`))

									if (ComponentPage)
										return (
											<PrivateRoute
												path={`/${m.url}`}
												component={ComponentPage}
												title={m.name}
												exact={true}
												key={m.url}
											/>
										)
								})}
							</>
						)}

						{/* Superadmin */}
						<PublicRoute
							path='/login_superadmin'
							component={ConsoleSuperAdmin}
							exact={true}
						/>

						<PrivateSuperAdminRoute
							path="/dashboard_administrator"
							component={DashboardAdministrator}
							exact={true}
						/>

						<PrivateSuperAdminRoute
							path='/sys_company_administrator'
							component={SysCompanyAdministrator}
							exact={true}
						/>

						<PrivateSuperAdminRoute
							path='/sys_company_clients_administrator'
							component={SysCompanyClientsAdministrator}
							exact={true}
						/>



						<PrivateSuperAdminRoute
							path='/mass_client_settings'
							component={MassClientSettings}
							exact={true}
						/>

						{/* Client */}
						<PublicClientRoute
							path='/login_client'
							component={ClientLogin}
							exact={true}
						/>
						
						<NewPublicClientRoute
							path='/client/company_qr_scanning'
							component={CompanyQRScanningsPage}
							exact={true}
						/>

						<NewPublicClientRoute
							path='/client/orders'
							component={OrdersPage}
							exact={true}
						/>

						<NewPublicClientRoute
							path='/client/notifications'
							component={NotificationsPage}
							exact={true}
							header={{
								headerTitle: currentTranslations?.notifications,
							}}
						/>

						<NewPublicClientRoute
							path='/client/reservations'
							component={ReservationsPage}
							exact={true}
							header={{
								headerTitle: currentTranslations?.reservations,
							}}
						/>

						<NewPublicClientRoute
							path='/client/search'
							component={SearchPage}
							exact={true}
						/>

						<NewPublicClientRoute
							path='/client/order_details_screen'
							component={OrderDetailsPage}
							exact={true}
							header={{
								headerTitle: currentTranslations?.orderDetails,
								contStyle: {
									backgroundColor: "#f9f9f9ff",
									"box-shadow": null,
								},
								headerStyle: {
									fontSize: "24px",
									"font-weight": "700",
								},
							}}
						/>

						<NewPublicClientRoute
							path='/client/products'
							component={ClientProductsPage}
							exact={true}
						/>

						<NewPublicClientRoute
							path='/client/stalls'
							component={FoodStallsPage}
							exact={true}
						/>

						<NewPublicClientRoute
							path='/client/account'
							component={Account}
							exact={true}
							header={{
								headerTitle: currentTranslations?.account,
							}}
						/>

						<NewPublicClientRoute
							path='/client/reservationform'
							component={ReservationFormPage}
							exact={true}
							header={{
								headerTitle: '',
								HeaderRight: ReservationFormHeader
							}}
						/>

						<NewPublicClientRoute
							path='/client/download_ruf'
							component={DownloadRufPage}
							exact={true}
						/>

						<PublicRoute
							path='/*'
							component={LoginRoute}
							// exact={true}
						/>
					</Switch>
				</Suspense>
			</BrowserRouter>
		</React.Fragment>
	)
}

const mapDispatchToProps = (dispatch) => ({
	loginWithToken: (parmas) => dispatch(loginWithToken(parmas)),
	clientLoginWithToken: (params) => dispatch(clientLoginWithToken(params)),
	loginWithFacebookToken: (token) =>
		dispatch(loginWithExternalToken(token, 'facebook')),
	loginWithGoogleToken: (token) =>
		dispatch(loginWithExternalToken(token, 'google')),
	loginSuperAdmin: (headers) => dispatch(loginSuperAdmin(headers)),
	setLanguage: (lang) => dispatch(setLanguage(lang)),
})

const mapStateToProps = (state) => ({
	user: state.app.user,
	isAuthenticated: !!state.app.user,
	isClientAuthenticated: !!state.app.client,
	isSuperAdmindAuthenticated: state.app?.superAdmin,
	currentTranslations: translations[state.app.lang],
})

export default connect(mapStateToProps, mapDispatchToProps)(Routers)
